(() => {
  'use strict';

  /*
   * ============================================================
   * ВКУСНО - МИНИМАЛНА ПОРЪЧКА ПО ДНИ
   * ============================================================
   *
   * Клиентска комуникация:
   * Минимална поръчка = 10€
   *
   * Технически минимум:
   * 8,99€
   *
   * Причина:
   * Малка абонаментна кутия 10€
   * с 10% Appstle отстъпка = 9€
   * и трябва да бъде допусната.
   *
   * Четвъртък и Неделя се проверяват отделно.
   * ============================================================
   */

  if (window.__vkusnoMinimumOrderLoaded) {
    return;
  }

  window.__vkusnoMinimumOrderLoaded = true;


  /*
   * ============================================================
   * НАСТРОЙКИ
   * ============================================================
   */

  const CONFIG = {
    technicalMinimum: 899,

    displayedMinimum: 1000,

    deliveryOptionName: 'Ден за доставка',

    feeVariantIds: [
      54446082195798,
      54446084489558
    ],

    days: {
      'четвъртък': {
        label: 'четвъртък'
      },

      'неделя': {
        label: 'неделя'
      }
    }
  };


  /*
   * ============================================================
   * SHOPIFY ROUTES
   * ============================================================
   */

  const shopRoot =
    window.Shopify?.routes?.root || '/';

  const cartUrl =
    shopRoot + 'cart.js';

  const nativeFetch =
    window.fetch.bind(window);


  /*
   * ============================================================
   * ВЪТРЕШНО СЪСТОЯНИЕ
   * ============================================================
   */

  let validationTimer = null;

  let validationPromise = null;

  let validateAgainAfterCurrent = false;

  let lastResult = null;


  /*
   * ============================================================
   * ПОМОЩНИ ФУНКЦИИ
   * ============================================================
   */

  const normalizeText = (value) => {
    return String(value || '')
      .trim()
      .toLocaleLowerCase('bg-BG');
  };


  const formatMoney = (cents) => {
    return new Intl.NumberFormat(
      'bg-BG',
      {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      }
    ).format(
      Number(cents || 0) / 100
    );
  };


  const isFeeVariant = (variantId) => {
    return CONFIG.feeVariantIds.includes(
      Number(variantId)
    );
  };


  /*
   * ============================================================
   * НАМИРАМЕ ДЕНЯ НА ПРОДУКТА
   * ============================================================
   */

  const getDeliveryDayFromItem = (
    item
  ) => {

    const detectDay = (value) => {
      const text =
        normalizeText(value);

      for (
        const day
        of Object.keys(CONFIG.days)
      ) {
        if (
          text.includes(day)
        ) {
          return day;
        }
      }

      return '';
    };


    const options =
      Array.isArray(
        item.options_with_values
      )
        ? item.options_with_values
        : [];


    const namedOption =
      options.find((option) => {
        return (
          normalizeText(option.name) ===
          normalizeText(
            CONFIG.deliveryOptionName
          )
        );
      });


    if (namedOption) {
      const day =
        detectDay(
          namedOption.value
        );

      if (day) {
        return day;
      }
    }


    for (const option of options) {
      const day =
        detectDay(
          option.value
        );

      if (day) {
        return day;
      }
    }


    const variantOptions =
      Array.isArray(
        item.variant_options
      )
        ? item.variant_options
        : [];


    for (
      const optionValue
      of variantOptions
    ) {
      const day =
        detectDay(
          optionValue
        );

      if (day) {
        return day;
      }
    }


    const titleDay =
      detectDay(
        item.variant_title
      );

    if (titleDay) {
      return titleDay;
    }


    return '';
  };


  /*
   * ============================================================
   * ЧЕТЕМ SHOPIFY КОЛИЧКАТА
   * ============================================================
   */

  const getCart = async () => {
    const response =
      await nativeFetch(
        cartUrl,
        {
          method: 'GET',

          headers: {
            Accept: 'application/json'
          },

          credentials: 'same-origin',

          cache: 'no-store'
        }
      );


    if (!response.ok) {
      throw new Error(
        'Не успяхме да проверим количката.'
      );
    }


    return response.json();
  };


  /*
   * ============================================================
   * ИЗЧИСЛЯВАМЕ СУМАТА ПО ДНИ
   * ============================================================
   */

  const analyzeCart = (cart) => {
    const dayTotals = {
      'четвъртък': 0,
      'неделя': 0
    };


    cart.items.forEach((item) => {
      const variantId =
        Number(
          item.variant_id ||
          item.id
        );


      if (
        isFeeVariant(variantId)
      ) {
        return;
      }


      const deliveryDay =
        getDeliveryDayFromItem(item);


      if (!deliveryDay) {
        return;
      }


      const lineTotal =
        Number(
          item.final_line_price ??
          item.line_price ??
          0
        );


      dayTotals[
        deliveryDay
      ] += lineTotal;
    });


    return dayTotals;
  };


  /*
   * ============================================================
   * ПРОВЕРЯВАМЕ МИНИМУМА
   * ============================================================
   */

  const buildValidationResult = (cart) => {
    const dayTotals =
      analyzeCart(cart);


    const invalidDays = [];


    for (
      const day
      of Object.keys(CONFIG.days)
    ) {
      const total =
        dayTotals[day];


      if (total <= 0) {
        continue;
      }


      if (
        total <
        CONFIG.technicalMinimum
      ) {
        invalidDays.push({
          day: day,

          label:
            CONFIG.days[day].label,

          total: total,

          missing:
            Math.max(
              CONFIG.displayedMinimum -
                total,
              0
            )
        });
      }
    }


    return {
      valid:
        invalidDays.length === 0,

      invalidDays:
        invalidDays,

      dayTotals:
        dayTotals,

      error:
        false
    };
  };


  /*
   * ============================================================
   * CHECKOUT ЕЛЕМЕНТИ
   * ============================================================
   */

  const getStandardCheckoutElements = () => {
    return Array.from(
      document.querySelectorAll(
        [
          'button[name="checkout"]',
          'input[name="checkout"]',
          'a[href*="/checkout"]'
        ].join(',')
      )
    );
  };


  /*
   * ============================================================
   * СЪОБЩЕНИЕТО КЪМ КЛИЕНТА
   * ============================================================
   */

  const getOrCreateMessage = () => {
    let message =
      document.getElementById(
        'vkusno-minimum-order-message'
      );


    if (message) {
      return message;
    }


    const checkoutButton =
      document.querySelector(
        [
          'button[name="checkout"]',
          'input[name="checkout"]'
        ].join(',')
      );


    if (!checkoutButton) {
      return null;
    }


    message =
      document.createElement('div');


    message.id =
      'vkusno-minimum-order-message';


    checkoutButton.parentNode.insertBefore(
      message,
      checkoutButton
    );


    return message;
  };


  const removeMessage = () => {
    const message =
      document.getElementById(
        'vkusno-minimum-order-message'
      );


    if (message) {
      message.remove();
    }
  };


  const buildMessageText = (result) => {
    if (result.error) {
      return (
        'Не успяхме да проверим минималната сума. ' +
        'Моля, опитай отново.'
      );
    }


    const invalidDays =
      result.invalidDays;


    if (invalidDays.length === 1) {
      const item =
        invalidDays[0];


      return (
        'Минималната поръчка е 10€ за всеки ден. ' +
        'Добави още ' +
        formatMoney(item.missing) +
        ' към поръчката си за ' +
        item.label +
        '.'
      );
    }


    const parts =
      invalidDays.map((item) => {
        return (
          formatMoney(item.missing) +
          ' за ' +
          item.label
        );
      });


    return (
      'Минималната поръчка е 10€ за всеки ден. ' +
      'Добави още ' +
      parts.join(' и ') +
      '.'
    );
  };


  const renderMessage = (result) => {
    if (
      result.valid &&
      !result.error
    ) {
      removeMessage();

      return;
    }


    const message =
      getOrCreateMessage();


    if (!message) {
      return;
    }


    message.textContent =
      buildMessageText(result);
  };


  /*
   * ============================================================
   * ЗАКЛЮЧВАМЕ / ОТКЛЮЧВАМЕ CHECKOUT
   * ============================================================
   */

  const setCheckoutDisabled = (
    disabled
  ) => {
    getStandardCheckoutElements()
      .forEach((element) => {
        if (
          'disabled' in element
        ) {
          if (disabled) {
            element.dataset
              .vkusnoMinimumDisabled =
              'true';


            element.disabled = true;


            element.setAttribute(
              'aria-disabled',
              'true'
            );
          } else if (
            element.dataset
              .vkusnoMinimumDisabled ===
            'true'
          ) {
            element.disabled = false;


            element.removeAttribute(
              'aria-disabled'
            );


            delete element.dataset
              .vkusnoMinimumDisabled;
          }


          return;
        }


        if (disabled) {
          element.classList.add(
            'vkusno-minimum-disabled-link'
          );


          element.setAttribute(
            'aria-disabled',
            'true'
          );
        } else {
          element.classList.remove(
            'vkusno-minimum-disabled-link'
          );


          element.removeAttribute(
            'aria-disabled'
          );
        }
      });
  };


  /*
   * ============================================================
   * ПРИЛАГАМЕ РЕЗУЛТАТА
   * ============================================================
   */

  const applyValidationState = (
    result,
    checking = false
  ) => {
    const blocked =
      checking ||
      !result ||
      !result.valid;


    document.body.classList.toggle(
      'vkusno-minimum-checking',
      checking
    );


    document.body.classList.toggle(
      'vkusno-minimum-invalid',
      !checking &&
        result &&
        !result.valid
    );


    setCheckoutDisabled(
      blocked
    );


    if (
      !checking &&
      result
    ) {
      renderMessage(result);
    }
  };


  /*
   * ============================================================
   * ГЛАВНА ПРОВЕРКА
   * ============================================================
   */

  const validateMinimumOrder =
    async () => {
      if (validationPromise) {
        validateAgainAfterCurrent =
          true;


        return validationPromise;
      }


      validationPromise = (
        async () => {
          try {
            const cart =
              await getCart();


            const result =
              buildValidationResult(
                cart
              );


            lastResult =
              result;


            applyValidationState(
              result,
              false
            );


            document.dispatchEvent(
              new CustomEvent(
                'vkusno:minimum-order-updated',
                {
                  detail: result
                }
              )
            );


            return result;
          } catch (error) {
            console.error(
              '[Вкусно минимална поръчка]',
              error
            );


            const errorResult = {
              valid: false,

              invalidDays: [],

              dayTotals: {},

              error: true
            };


            lastResult =
              errorResult;


            applyValidationState(
              errorResult,
              false
            );


            return errorResult;
          }
        }
      )();


      try {
        return await validationPromise;
      } finally {
        validationPromise = null;


        if (
          validateAgainAfterCurrent
        ) {
          validateAgainAfterCurrent =
            false;


          setTimeout(() => {
            scheduleValidation(100);
          }, 0);
        }
      }
    };


  /*
   * ============================================================
   * DEBOUNCE
   * ============================================================
   */

  const scheduleValidation = (
    delay = 250
  ) => {
    clearTimeout(
      validationTimer
    );


    applyValidationState(
      lastResult,
      true
    );


    validationTimer =
      setTimeout(() => {
        validateMinimumOrder();
      }, delay);
  };


  /*
   * ============================================================
   * ЗАЩИТА ПРИ КЛИК КЪМ CHECKOUT
   * ============================================================
   */

  document.addEventListener(
    'click',

    (event) => {
      const checkoutElement =
        event.target.closest?.(
          [
            'button[name="checkout"]',
            'input[name="checkout"]',
            'a[href*="/checkout"]'
          ].join(',')
        );


      if (!checkoutElement) {
        return;
      }


      if (
        !lastResult ||
        !lastResult.valid ||
        validationPromise
      ) {
        event.preventDefault();

        event.stopImmediatePropagation();


        scheduleValidation(0);
      }
    },

    true
  );


  /*
   * ============================================================
   * СЛЕДИМ ПРОМЕНИ В КОЛИЧКАТА
   * ============================================================
   */

  document.addEventListener(
    'change',

    (event) => {
      if (
        event.target.closest?.(
          [
            'cart-items',
            'cart-drawer-items',
            '#main-cart-items',
            '#CartDrawer'
          ].join(',')
        )
      ) {
        scheduleValidation(700);
      }
    }
  );


  document.addEventListener(
    'click',

    (event) => {
      if (
        event.target.closest?.(
          [
            'quantity-input',
            '.quantity__button',
            'cart-remove-button',
            '.cart-remove-button'
          ].join(',')
        )
      ) {
        scheduleValidation(900);
      }
    }
  );


  document.addEventListener(
    'vkusno:delivery-fees-updated',
    () => {
      scheduleValidation(100);
    }
  );


  document.addEventListener(
    'cart:refresh',
    () => {
      scheduleValidation(150);
    }
  );


  document.addEventListener(
    'cart:updated',
    () => {
      scheduleValidation(150);
    }
  );


  /*
   * ============================================================
   * DAWN PUB / SUB
   * ============================================================
   */

  const attachDawnListener = () => {
    try {
      if (
        typeof subscribe ===
          'function' &&
        typeof PUB_SUB_EVENTS !==
          'undefined' &&
        PUB_SUB_EVENTS.cartUpdate
      ) {
        subscribe(
          PUB_SUB_EVENTS.cartUpdate,

          () => {
            scheduleValidation(180);
          }
        );
      }
    } catch (error) {
      console.warn(
        '[Вкусно минимум] Dawn listener fallback',
        error
      );
    }
  };


  /*
   * ============================================================
   * CSS
   * ============================================================
   */

  const injectStyles = () => {
    if (
      document.getElementById(
        'vkusno-minimum-order-styles'
      )
    ) {
      return;
    }


    const style =
      document.createElement('style');


    style.id =
      'vkusno-minimum-order-styles';


    style.textContent = `
      #vkusno-minimum-order-message {
        width: 100%;
        margin: 0 0 14px;
        padding: 13px 15px;
        border-radius: 14px;
        background: rgba(229, 54, 44, 0.10);
        border: 1px solid rgba(229, 54, 44, 0.22);
        color: #b72d25;
        font-size: 13px;
        line-height: 1.45;
        font-weight: 800;
        text-align: center;
      }

      .vkusno-minimum-disabled-link {
        pointer-events: none !important;
        opacity: 0.48 !important;
      }

      body.vkusno-minimum-invalid
        .cart__dynamic-checkout-buttons,

      body.vkusno-minimum-invalid
        .additional-checkout-buttons,

      body.vkusno-minimum-invalid
        #dynamic-checkout-cart,

      body.vkusno-minimum-invalid
        shopify-accelerated-checkout,

      body.vkusno-minimum-checking
        .cart__dynamic-checkout-buttons,

      body.vkusno-minimum-checking
        .additional-checkout-buttons,

      body.vkusno-minimum-checking
        #dynamic-checkout-cart,

      body.vkusno-minimum-checking
        shopify-accelerated-checkout {
        display: none !important;
      }

      button[name="checkout"]:disabled,
      input[name="checkout"]:disabled {
        opacity: 0.48 !important;
        cursor: not-allowed !important;
      }
    `;


    document.head.appendChild(
      style
    );
  };


  /*
   * ============================================================
   * СТАРТИРАНЕ
   * ============================================================
   */

  const start = () => {
    injectStyles();

    attachDawnListener();


    applyValidationState(
      null,
      true
    );


    validateMinimumOrder();
  };


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }


  window.addEventListener(
    'pageshow',

    () => {
      scheduleValidation(100);
    }
  );


  /*
   * ============================================================
   * DEBUG
   * ============================================================
   */

  window.VkusnoMinimumOrder = {
    validate:
      validateMinimumOrder,

    getCart:
      getCart,

    config:
      CONFIG
  };
})();